// extracted by mini-css-extract-plugin
export default {"container":"resetpassword_container__R1eoZ","signin":"resetpassword_signin__9aChW","button":"resetpassword_button__9t6vx","link":"resetpassword_link__GlTDN"};